export default __webpack_public_path__ + "0ff96c625d74210874a72a44babbc8de.png";